<dx-popup
    #multipleBoardApprovalEditor
    width="60%"
    height="65%"
    [title]="actionTitle"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        class="cc-vertical-center-cell-data-grid top-padding"
                        [highlightChanges]="true"
                        [repaintChangesOnly]="true"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [dataSource]="recordsToProcess"
                    >
                        <dxo-pager [visible]="false"></dxo-pager>
                        <dxo-paging [enabled]="false"></dxo-paging>

                        <dxo-editing
                            mode="cell"
                            refreshMode="full"
                            selectTextOnEditStart="true"
                            [allowUpdating]="true"
                            [useIcons]="true"
                        ></dxo-editing>

                        <dxi-column
                            dataField="userNameDisplayText"
                            dataType="string"
                            caption="User"
                            cellTemplate="userNameDisplayCellTemplate"
                        ></dxi-column>

                        <dxi-column
                            dataType="string"
                            caption="Process ID"
                            dataField="processId"
                            [width]="110"
                            [allowEditing]="false"
                            [showEditorAlways]="false"
                            [groupIndex]="0"
                            groupCellTemplate="groupProcessCellTemplate"
                        ></dxi-column>

                        <ng-container *ngIf="multipleBoardApprovalAction?.allowResponseToOwner">
                            <dxi-column
                                dataType="string"
                                caption="Response To Owner"
                                dataField="responseToOwner"
                                [allowEditing]="true"
                                [showEditorAlways]="true"
                                editCellTemplate="responseToOwnerEditTemplate"
                            ></dxi-column>
                        </ng-container>

                        <ng-container *ngIf="multipleBoardApprovalAction?.reasonRequiredForAction">
                            <dxi-column
                                dataField="notes"
                                dataType="string"
                                caption="Notes"
                                editCellTemplate="notesEditTemplate"
                                [allowSorting]="false"
                                [allowEditing]="true"
                                [showEditorAlways]="true"
                            ></dxi-column>
                        </ng-container>

                        <div *dxTemplate="let data of 'groupProcessCellTemplate'">
                            <div
                                *ngIf="!!data.data"
                                class="normal-text cc-text-color"
                                [innerHTML]="getProcessIdGroupTemplateTitle(data.data)"
                            ></div>
                        </div>

                        <div *dxTemplate="let data of 'userNameDisplayCellTemplate'">
                            <app-user-bio-link
                                [user]="data.data.userInfo"
                                [communityId]="data.data.communityId"
                            ></app-user-bio-link>
                        </div>

                        <div *dxTemplate="let item of 'itemNumber'">
                            <span>
                                {{ item.row.rowIndex + 1 }}
                            </span>
                        </div>

                        <div *dxTemplate="let row of 'responseToOwnerEditTemplate'">
                            <dx-text-box [height]="50" [(value)]="row.data.responseToOwner"></dx-text-box>
                        </div>

                        <div *dxTemplate="let row of 'notesEditTemplate'">
                            <dx-text-box [height]="50" [(value)]="row.data.notes"></dx-text-box>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
